import React, {useState, useEffect} from 'react';
import { useTranslation } from "react-i18next";
import { CircularProgress, Typography } from '@mui/material';
import GlobeGl from '../../components/globe/GlobeGl';

const MyMobileGlobe = () => {
  const { t } = useTranslation();
  const [id, setId] = useState(-1);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get('id');
    setId(id);
  }, [])

  if (id === -1) {
    return (
      <div className="loading-container">
        <CircularProgress size={50} />
        <Typography>{t('loaders.fetching')}</Typography>
      </div>
    )
  } else {
    return (
      <GlobeGl exparienceId={id} />
    )
  }

}

export default MyMobileGlobe;